import { Route, Switch } from "polyrouter";
import React from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { ClaritiSetupOverview } from "./ClaritiSetupOverview";
import { LicenseActivation } from "../../Shared/Setup/Activate/LicenseActivation";

export const ClaritiSetupRouter: React.FC = () => {
  const { t } = useTranslation();

  const { Content } = Layout;
  return (
    <Content className="clariti-setup">
      <Content.Title className="mb-1">{t("SETUP")}</Content.Title>
      <p className="mb-15">{t("SETUP_DESCRIPTION")}</p>
      <Switch nest>
        <Route path="/activate">
          <LicenseActivation />
        </Route>
        <Route path="">
          <ClaritiSetupOverview />
        </Route>
      </Switch>
    </Content>
  );
};
